import { render } from "./BugReports.vue?vue&type=template&id=0cb1f180"
import script from "./BugReports.vue?vue&type=script&lang=js"
export * from "./BugReports.vue?vue&type=script&lang=js"
script.render = render

export default script